import { render, staticRenderFns } from "./otOverlapDisplayModal.vue?vue&type=template&id=8b4ba770&scoped=true&"
import script from "./otOverlapDisplayModal.vue?vue&type=script&lang=js&"
export * from "./otOverlapDisplayModal.vue?vue&type=script&lang=js&"
import style0 from "./otOverlapDisplayModal.vue?vue&type=style&index=0&id=8b4ba770&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4ba770",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VDialog,VRow,VSpacer})
